import { Popover } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import { useNavigate } from 'react-router-dom'
import WizrFlexLayout from '../../components/WizrFlexLayout'
import styled from 'styled-components'
import ViewIcon from '../../assets/icons/ViewIcon'
import { useAuth } from '../../authContext'

const ProductActionPopOverContent = ({ product }: any): JSX.Element => {

  const { hasAcces } = useAuth();

  const navigate = useNavigate()
  const onEditAction = () => {
    // showModal(MODAL_TYPES.UPDATE_PRODUCTS,{
    //   productDetails:product,
    //   onCancel: hideModal,
    // })
    navigate('/product', { state: { product: product, view: false } })
  }

  const onViewAction = () => {
    navigate('/product', { state: { product: product, view: true } })

  }
  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>

      <WizrButton
        icon={<ViewIcon />}
        text='View'
        type='text'
        onClick={() => { onViewAction() }}
        justifyContent='flex-start'
        disabled={!hasAcces('view_product')}

      />
      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={() => { onEditAction() }}
        justifyContent='flex-start'
        disabled={!hasAcces('edit_product')}

      />
    </WizrFlexLayout>
  )
}

const ProductActionPopOver = (productDetails: any): JSX.Element => {
  const product = productDetails?.productDetails

  return (
    <Popover
      content={
        <ProductActionPopOverContent
          product={product}
        />
      }
      trigger='click'
    >
      <StyledButton icon={<MoreIcon />} text='' type='text' style={{ height: '40px', width: '40px', borderRadius: '50px' }} />
    </Popover>
  )
}

export default ProductActionPopOver

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`;
